<template>
    <el-config-provider id="app" :button="{ autoInsertSpace: false }">
        <router-view v-if="isRefresh"></router-view>
    </el-config-provider>
</template>

<script>
import colorTool from "@/utils/color";
export default {
    name: "App",
    data: () => ({
        isRefresh: true,
    }),
    computed: {
    },
    created() {
        //设置主题颜色
        const app_color =
            this.$TOOL.data.get("APP_COLOR") || this.$CONFIG.COLOR;
        if (app_color) {
            colorTool.setAppColors(app_color);
        }
    },
    provide() {
        return {
            refresh: this.refresh,
        };
    },
    methods: {
        refresh() {
            this.isRefresh = false;
            this.$nextTick(() => {
                this.isRefresh = true;
            });
        },
    },
};
</script>

<style>
*{margin: 0; padding: 0; font-size: 62.5%; font-style: normal}
li, ol, ul {
  font: inherit;
  list-style: none;
}
body{min-width: 120rem}
#app{min-width: 120rem; display: block; overflow: hidden}
.anchorBL a {
  display: none;
}

.anchorBL img {
  display: none;
}

.anchorBL span {
  display: none !important;
}
.swiper-pagination-bullet{
  /*background: #ffedef;*/
  background: #e5e5e5;
  opacity: 1;

}
.swiper-horizontal>.swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal, .swiper-pagination-custom, .swiper-pagination-fraction{margin-top: 8rem}
.swiper-pagination-bullet-active{
  /*width: .8rem;*/
  /*height: .8rem;*/
  border-radius: .6rem;
  /*background: linear-gradient(90deg, rgba(255, 113, 114, 1), rgba(255, 237, 239, 1))*/
  background: rgba(255, 122, 123, 1);
}
.swiper-button-prev, .swiper-rtl .swiper-button-next{}
.swiper-button-next:hover{
  background: url("assets/right1.png") no-repeat;background-size: contain;
}
.swiper-button-prev:hover{
  background: url("assets/left1.png") no-repeat;background-size: contain;
}
.swiper-button-next, .swiper-button-prev{top:50%;transform: translate(-50%,-30%); width:3.6rem; height: 3.6rem }
.swiper-button-next::after, .swiper-button-prev::after{content: ''}
.swiper-button-next{background: url("assets/right.png") no-repeat; background-size: contain; right:50%; margin-right: -700px }
.swiper-button-prev{background: url("assets/left.png") no-repeat; background-size: contain ;left:50%; margin-left: -670px }
div::-webkit-scrollbar {
  width: 4px;
  height: 0;
}
div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  background:#ccc;
}
div::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: #eee;
}
.custom-notification {
    font-size: 16px !important; /* 全局字体大小 */
}
/* 通知标题字体（可选：如需单独调整标题） */
.custom-notification .el-notification__title {
    font-size: 18px !important;
    font-weight: 500 !important;
}
/* 通知内容字体（可选：如需单独调整内容） */
.custom-notification .el-notification__content {
    font-size: 16px !important;
    line-height: 1.6 !important; /* 行高：优化多行文本可读性 */
}

/* -------------------------- ElMessageBox 确认弹窗样式 -------------------------- */
/* 1. 弹窗整体字体放大 */
.custom-login-modal {
    font-size: 16px !important;
}
/* 弹窗内容字体（确认提示文本） */
.custom-login-modal .el-message-box__content {
    font-size: 22px !important;
    line-height: 1.6 !important;
    margin: 15px 0 !important; /* 增加内容上下间距，避免拥挤 */
}
/* 2. 确认按钮：红色（覆盖默认蓝色） */
.custom-red-btn {
    background-color: #F56C6C !important; /* Element Plus 红色主题色（可替换为自定义红色） */
    border-color: #F56C6C !important;
    color: #fff !important;
}
/* 按钮 hover 效果（保持红色加深，避免变回蓝色） */
.custom-red-btn:hover {
    background-color: #E64C4C !important;
    border-color: #E64C4C !important;
}
/* 按钮聚焦效果（可选：优化键盘导航样式） */
.custom-red-btn:focus {
    box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.2) !important;
}
/* 408弹窗 - 精准放大内容文本（核心样式） */
.custom-login-modal .el-message-box__message {
    font-size: 22px !important; /* 重点：将文本放大到18px（可按需调整为20px等） */
    line-height: 1.8 !important; /* 增加行高，避免多行文本拥挤 */
    margin: 20px 0 !important; /* 增加上下间距，提升视觉舒适度 */
    color: #333 !important; /* 可选：加深文本颜色，更醒目 */
}
::v-deep .custom-notification {
    font-size: 22px !important;
}
::v-deep .custom-red-btn {
    background-color: #F56C6C !important;
    border-color: #F56C6C !important;
}
/* 强制修改弹窗样式，提高优先级 */
.el-message-box.logout-confirm-modal {
    width: 600px !important;
    min-height: 100px !important;
}

/* 标题样式 */
.el-message-box.logout-confirm-modal .el-message-box__title {
    font-size: 24px !important;
    margin-bottom: 20px !important;
}

/* 提示内容样式 */
.el-message-box.logout-confirm-modal .el-message-box__content {
    font-size: 80px !important;  /* 显著增大提示文字 */
    padding: 30px 20px !important;
    line-height: 1.8 !important;
}

/* 按钮区域样式 */
.el-message-box.logout-confirm-modal .el-message-box__btns {
    padding: 20px !important;
}

/* 按钮文字样式 */
.el-message-box.logout-confirm-modal .el-button {
    font-size: 22px !important;
    padding: 10px 25px !important;
    margin: 0 10px !important;
}
/* 调整通知整体样式 */
.el-notification {
    width: 350px !important; /* 增加通知框宽度 */
    padding: 15px 20px !important; /* 增加内边距 */
}

/* 标题样式 */
.el-notification__title {
    font-size: 20px !important; /* 标题字体大小 */
    margin-bottom: 10px !important;
    line-height: 1.5 !important;
}

/* 内容样式 */
.el-notification__content {
    font-size: 18px !important; /* 内容字体大小 */
    line-height: 1.6 !important; /* 行高，增强可读性 */
}

/* 成功类型通知的图标大小（可选） */
.el-notification--success .el-notification__icon {
    font-size: 24px !important; /* 图标大小 */
    margin-right: 15px !important;
}
</style>
